@if (loading) {
  <div class="spinner-container">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
<app-spo-detail-form [isEdit]="false" (updatedSpo)="formUpdate($event)"
  (formIsLoading)="manageLoadingForm($event)"
(formIsTouched)="isStepTouched($event)"></app-spo-detail-form>
